export const authText = {
  id: {
    login: {
      title: 'Masuk ke akun UCP',
      subtitle: 'Gunakan akun UCP GTA:WestCounty untuk mengakses layanan pemain.',
      submit: 'Masuk',
      alt: '',
      altAction: '',
      altHref: '/',
    },
    register: {
      title: 'Daftar UCP GTA:WestCounty',
      subtitle: 'Buat akun UCP untuk layanan pemain GTA:WestCounty. PIN verifikasi akan dikirim ke email Gmail kamu.',
      submit: 'Daftar UCP',
      alt: 'Sudah memiliki akun?',
      altAction: 'Masuk sekarang',
      altHref: '/account/login',
    },
    pin: {
      title: 'Verifikasi PIN',
      subtitle: 'Masukkan PIN format WC-1234 yang sudah dikirim ke',
      submit: 'Verifikasi PIN',
      alt: 'Ingin pakai akun lain?',
      altAction: 'Kembali ke login',
      altHref: '/account/login',
    },
    fields: {
      usernameEmail: 'Username atau Email',
      username: 'Username UCP',
      email: 'Email Gmail',
      password: 'Kata Sandi',
      confirmPassword: 'Konfirmasi Kata Sandi',
      pin: 'PIN Verifikasi',
      usernameEmailPlaceholder: 'Masukkan username atau email',
      usernamePlaceholder: 'Contoh: westcounty01',
      emailPlaceholder: 'Contoh: nama@gmail.com',
      passwordPlaceholder: 'Masukkan kata sandi',
      confirmPasswordPlaceholder: 'Ulangi kata sandi',
      pinPlaceholder: 'Contoh: WC-1234',
    },
    meta: {
      remember: 'Ingat saya',
      forgot: 'Lupa Password atau Username?',
      caps: 'Caps Lock sedang aktif',
      divider: 'atau',
      language: 'Pilih bahasa',
      copyright: '© GTA:WestCounty. All rights reserved.',
      backHome: 'Kembali ke Beranda',
      terms: 'Gunakan Gmail aktif. PIN verifikasi akan dikirim ke email dan disimpan di kolom pin. Kolom verifcode sengaja dikosongkan.',
      passwordHint: 'Minimal 6 karakter. Gunakan kombinasi yang tidak mudah ditebak.',
      registerSuccess: 'Pendaftaran berhasil. Cek email kamu untuk melihat PIN verifikasi UCP.',
      loginSuccess: 'Login berhasil. Mengalihkan ke dashboard...' ,
      pinRequired: 'Akun belum diverifikasi. Masukkan PIN yang sudah dikirim ke email.',
      pinNotice: 'PIN dikirim ke email',
      pinInvalid: 'PIN harus format WC-1234.',
      pinSuccess: 'PIN berhasil diverifikasi. Mengalihkan ke dashboard...' ,
      pinResent: 'PIN baru sudah dikirim ke email.',
      resendPin: 'Kirim ulang PIN',
      resendReady: 'Belum menerima PIN? Kamu bisa kirim ulang sekarang.',
      resendWait: 'Kirim ulang tersedia dalam {seconds} detik.',
      processing: 'Memproses...',
      networkError: 'Tidak dapat menghubungi server. Periksa API/backend atau koneksi hosting.',
      passwordMismatch: 'Konfirmasi kata sandi tidak sama.',
    },
  },
  en: {
    login: {
      title: 'Sign in to UCP',
      subtitle: 'Use your GTA:WestCounty UCP account to access player services.',
      submit: 'Login',
      alt: '',
      altAction: '',
      altHref: '/',
    },
    register: {
      title: 'Register GTA:WestCounty UCP',
      subtitle: 'Create a UCP account for GTA:WestCounty player services. The verification PIN will be sent to your Gmail address.',
      submit: 'Register UCP',
      alt: 'Already have an account?',
      altAction: 'Sign in now',
      altHref: '/account/login',
    },
    pin: {
      title: 'Verify PIN',
      subtitle: 'Enter the WC-1234 PIN sent to',
      submit: 'Verify PIN',
      alt: 'Want to use another account?',
      altAction: 'Back to login',
      altHref: '/account/login',
    },
    fields: {
      usernameEmail: 'Username or Email',
      username: 'UCP Username',
      email: 'Gmail Address',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      pin: 'Verification PIN',
      usernameEmailPlaceholder: 'Enter username or email',
      usernamePlaceholder: 'Example: westcounty01',
      emailPlaceholder: 'Example: name@gmail.com',
      passwordPlaceholder: 'Enter your password',
      confirmPasswordPlaceholder: 'Repeat your password',
      pinPlaceholder: 'Example: WC-1234',
    },
    meta: {
      remember: 'Remember me',
      forgot: 'Forgot Password or Username?',
      caps: 'Caps Lock is ON',
      divider: 'or',
      language: 'Choose language',
      copyright: '© GTA:WestCounty. All rights reserved.',
      backHome: 'Back to Home',
      terms: 'Use an active Gmail address. The verification PIN will be sent to your email and stored in the pin column. The verifcode column is intentionally left empty.',
      passwordHint: 'Minimum 6 characters. Use a password that is not easy to guess.',
      registerSuccess: 'Registration successful. Check your email for the UCP verification PIN.',
      loginSuccess: 'Login successful. Redirecting to dashboard...' ,
      pinRequired: 'This account is not verified. Enter the PIN sent to your email.',
      pinNotice: 'PIN sent to',
      pinInvalid: 'PIN must use WC-1234 format.',
      pinSuccess: 'PIN verified successfully. Redirecting to dashboard...' ,
      pinResent: 'A new PIN has been sent to your email.',
      resendPin: 'Resend PIN',
      resendReady: 'Did not receive the PIN? You can resend it now.',
      resendWait: 'Resend available in {seconds} seconds.',
      processing: 'Processing...',
      networkError: 'Unable to reach the server. Check the API/backend or hosting connection.',
      passwordMismatch: 'Password confirmation does not match.',
    },
  },
};
